"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LogoTextHeaderFields;
exports.useStyles = void 0;

var React = _interopRequireWildcard(require("react"));

var _HeaderFields = _interopRequireDefault(require("../fields/HeaderFields"));

var _usePkpass2 = require("../usePkpass");

var _types = require("../../../../types");

var _ImagePreview = _interopRequireDefault(require("../images/ImagePreview"));

var _reactJss = require("react-jss");

var _Theme = require("../../Theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useStyles = (0, _reactJss.createUseStyles)({
  logoTextHeaderFields: {
    display: 'flex',
    flexDirection: 'row',
    width: function width(_ref) {
      var theme = _ref.theme;
      return 320 * theme.scale;
    },
    marginBottom: function marginBottom(_ref2) {
      var theme = _ref2.theme;
      return 12 * theme.scale;
    }
  },
  logoContainer: {
    //padding: ({ theme }) => `0 ${12 * theme.scale}`,
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    maxWidth: function maxWidth(_ref3) {
      var theme = _ref3.theme;
      return theme.scale * 160;
    }
  },
  logoTextContainer: {
    padding: function padding(_ref4) {
      var theme = _ref4.theme;
      return theme.scale * 5;
    },
    paddingLeft: function paddingLeft(_ref5) {
      var theme = _ref5.theme;
      return theme.scale * 12;
    },
    color: function color(_ref6) {
      var theme = _ref6.theme;
      return theme.foregroundColor;
    },
    float: 'left',
    fontWeight: 'bold',
    height: function height(_ref7) {
      var theme = _ref7.theme;
      return theme.scale * 25;
    },
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    fontSize: function fontSize(_ref8) {
      var theme = _ref8.theme;
      return 22 * theme.scale;
    },
    '&:hover': {
      cursor: function cursor(_ref9) {
        var clickableLogoText = _ref9.clickableLogoText;
        return clickableLogoText ? 'pointer' : undefined;
      },
      opacity: function opacity(_ref10) {
        var clickableLogoText = _ref10.clickableLogoText;
        return clickableLogoText ? 0.7 : undefined;
      }
    }
  },
  headerFieldsContainer: {
    position: 'absolute',
    left: '50%',
    width: function width(_ref11) {
      var theme = _ref11.theme;
      return theme.scale * 160;
    },
    maxWidth: function maxWidth(_ref12) {
      var theme = _ref12.theme;
      return theme.scale * 160;
    }
  }
});
exports.useStyles = useStyles;

function LogoTextHeaderFields() {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      pass = _usePkpass.pass,
      language = _usePkpass.language,
      onLogoTextClick = _usePkpass.onLogoTextClick,
      images = _usePkpass.images;

  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    theme: theme,
    clickableLogoText: !!onLogoTextClick
  });
  var value = pass.logoText;

  if (value && typeof value !== 'string') {
    value = value[language];
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.logoTextHeaderFields
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logoContainer
  }, images[_types.ImageTypes.logo] && /*#__PURE__*/React.createElement(_ImagePreview.default, {
    imageType: _types.ImageTypes.logo
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.logoTextContainer,
    onClick: onLogoTextClick
  }, value)), /*#__PURE__*/React.createElement("div", {
    className: classes.headerFieldsContainer
  }, /*#__PURE__*/React.createElement(_HeaderFields.default, null)));
}
//# sourceMappingURL=LogoTextHeaderFields.js.map